import './App.css';
import './index.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';
import Login from './pages/Login';
import 'bootstrap/dist/css/bootstrap.min.css';
import Main from './pages/Main.js';
import Search from './pages/Search.js';
import Event from './pages/Event.js';
import BuyCoins from './pages/BuyCoins.js';
import History from './pages/History.js';
import Artist from './pages/Artist.js';
import Playlist from './pages/Playlist.js';
import Shoutout from './pages/Shoutout.js';
import Location from './pages/Location.js';
import AllArtists from './pages/AllArtists.js';
import { useEffect, useRef, useState } from 'react';
import Support from './pages/Support.js';
import Redeem from './pages/redeem.js';
import Dj from './pages/Dj.js';
import Music from './pages/Music.js';
import MusicPage from './pages/MusicPage.js';
import RudeLounge from './pages/Share.js';
import VenuePage from './pages/menu.js';
import { CartProvider } from './pages/CartContex.js';
import CartPage from './pages/cart.js';
import { StatsigProvider, useClientAsyncInit } from '@statsig/react-bindings';
import ShoutOutOptions from './pages/shoutOutOptions.js';
import LiveUsersPage from './pages/LiveUser.js';
import InsufficientCoinsPage from './pages/InsufficientCoinsPage.js';
import MyHistoryPage from './pages/ChanceHistory.js';
function App() {
  const [auth, setAuth] = useState(false);
  const [isMobile, setIsMobile] = useState(true);
  const userId = localStorage.getItem('userId') || 'defaultUserId';
  useEffect(() => {
    const mobileCheck = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    setIsMobile(mobileCheck);
  }, []);

  const { client } = useClientAsyncInit(
    'client-obaU0QwVJfDFmg2K1bW3QNDNw2kSK0aYuPrAfs0kHVN',
    {
      userID: userId,
      custom: {
        name: localStorage.getItem('name'),
      },
    }
  );
  useEffect(() => {
    const handleBeforeInstallPrompt = e => {
      e.preventDefault(); // Suppress automatic install popup
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener(
        'beforeinstallprompt',
        handleBeforeInstallPrompt
      );
    };
  }, []);
  useEffect(() => {
    const checkAuthAndHandleDeepLinks = () => {
      const userAgent = navigator.userAgent || navigator.vendor || '';
      const isAndroid = /android/i.test(userAgent);
      const isIOS = /iPad|iPhone|iPod/.test(userAgent);

      // Store config
      const playStoreBaseURL = 'https://play.google.com/store/apps/details';
      const androidPackage = 'com.tringbox.tringuser';
      const appStoreBaseURL =
        'https://apps.apple.com/in/app/tringbox/id6748858527';

      const path = window.location.pathname;
      const search = window.location.search;

      // A deep link is any /launch or /launch/... URL
      const isLaunchLink = path === '/launch' || path.startsWith('/launch/');

      // Not a deep link -> run the normal auth flow
      if (!isLaunchLink) {
        const token = localStorage.getItem('tringAuthToken');
        if (!token) {
          localStorage.clear();
        }
        setAuth(true);
        return;
      }

      // Strip the /launch prefix to get the real target path
      // e.g. /launch/venues/123 -> /venues/123 ; /launch -> /
      const deepLinkPath =
        path === '/launch' ? '/' : path.replace('/launch', '');

      // Read query params. `isredirect` is a web-only control flag and must NOT
      // be forwarded into the app / store deep link.
      const params = new URLSearchParams(search);
      const trackId = params.get('trackId');
      const isRedirect = params.get('isredirect') === 'true';
      params.delete('isredirect');
      const cleanedSearch = params.toString() ? `?${params.toString()}` : '';

      // Keep the (cleaned) query string so params like ?trackId= / ?referralCode= survive
      const deepLinkTarget = deepLinkPath + cleanedSearch;

      const fullLink = window.location.origin + deepLinkTarget;

      // Track links normally fall back to the web player instead of the store.
      // Exception: if `isredirect=true` is also present, use the store DDL instead.
      const isTrackWebFallback = !!trackId && !isRedirect;
      const trackWebURL = `https://player.tringbox.ai/track/?trackId=${trackId}`;

      // Deferred deep link for the Play Store: referrer = deep_link=<encoded target>
      // e.g. /track?trackId=abc -> referrer=deep_link%3D%252Ftrack%253FtrackId%253Dabc
      const referrer = 'deep_link=' + encodeURIComponent(deepLinkTarget);
      const playStoreURL = `${playStoreBaseURL}?id=${androidPackage}&referrer=${encodeURIComponent(
        referrer
      )}`;

      // Keep /launch in the URL for order discount paths
      const isOrderDiscount = path.match(/^\/launch\/order\/.*\/discount/);

      if (isAndroid || isIOS) {
        window.history.replaceState(
          {},
          '',
          isOrderDiscount ? path + cleanedSearch : deepLinkTarget
        );

        // Try opening the app (routes inside the app if installed)
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = fullLink;
        document.body.appendChild(iframe);

        // Fallback if the app is not installed:
        //  - track links without isredirect -> web player
        //  - everything else (incl. track + isredirect=true) -> Play Store / App Store DDL
        const fallbackURL = isTrackWebFallback
          ? trackWebURL
          : isAndroid
            ? playStoreURL
            : appStoreBaseURL;
        const fallbackTimer = setTimeout(() => {
          window.location.href = fallbackURL;
        }, 500);

        window.addEventListener('pagehide', () => {
          clearTimeout(fallbackTimer);
        });
      } else {
        // Desktop - track links go to the web player, everything else to the web app
        if (isTrackWebFallback) {
          window.location.href = trackWebURL;
        } else if (isOrderDiscount) {
          setAuth(true); // Already on the correct URL, no redirect needed
        } else {
          window.location.href = fullLink;
        }
      }
    };

    checkAuthAndHandleDeepLinks();
  }, []);

  if (!isMobile) {
    return (
      <div
        style={{
          height: '100vh',
          width: '100vw',
          background: 'black',
          color: 'white',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            position: 'relative',
            width: '100%',
            height: '0',
            paddingTop: '56.2225%',
          }}
        >
          <iframe
            loading="lazy"
            style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              top: 0,
              left: 0,
              border: 'none',
            }}
            src="https://www.canva.com/design/DAGiS1yUBNA/9WPtLyk8RxaynJI1yHBg2A/view?embed"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    );
  }

  return auth ? (
    <StatsigProvider client={client}>
      <CartProvider>
        <Router>
          <div
            className="App d-flex justify-content-center align-items-center w-100"
            style={{ backgroundColor: isMobile ? 'white' : 'black' }}
          >
            <div
              style={{
                width: isMobile ? '100%' : '370px',
                backgroundColor: 'white',
              }}
            >
              <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/main" element={<Main />} />
                <Route path="/buy" element={<BuyCoins />} />
                <Route path="/buy/secret/:secretId" element={<BuyCoins />} />
                <Route path="/history" element={<History />} />
                <Route path="/searchSong" element={<Search />} />
                <Route path="/venues/:vid" element={<Event />} />
                <Route path="/partner/:pid" element={<Event />} />
                <Route path="/artist" element={<Artist />} />
                <Route path="/playlist" element={<Playlist />} />
                <Route path="/shoutout" element={<Shoutout />} />
                <Route path="/location" element={<Location />} />
                <Route path="/allartists" element={<AllArtists />} />
                <Route path="/support" element={<Support />} />
                <Route path="/dj" element={<Dj />} />
                <Route path="/redeem" element={<Redeem />} />
                <Route path="/MusicPage" element={<MusicPage />} />
                <Route path="/music" element={<Music />} />
                <Route path="/share" element={<RudeLounge />} />
                <Route path="/menu" element={<VenuePage />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/live-users/:vid" element={<LiveUsersPage />} />
                <Route path="/ChanceHistory" element={<MyHistoryPage />} />
                <Route
                  path="/insufficient-coins"
                  element={<InsufficientCoinsPage />}
                />
                <Route
                  path="/shout-out-options"
                  element={<ShoutOutOptions />}
                />
              </Routes>
            </div>
          </div>
        </Router>
      </CartProvider>
    </StatsigProvider>
  ) : (
    <div
      className="d-flex justify-content-center align-items-center px-3"
      style={{
        backgroundColor: isMobile ? 'white' : 'black',
        height: '100dvh',
        width: '100dvw',
      }}
    >
      <div
        className="d-flex flex-column align-items-center justify-content-center"
        style={{
          gap: '15px',
          background: 'white',
          width: isMobile ? '100%' : '370px',
          height: '100%',
        }}
      >
        <div
          className="mb-0"
          style={{
            backgroundColor: 'linear-gradient(90deg, #CC151E 0%, #8A325D 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            display: 'inline-block',
            fontSize: 'clamp(0px,10vw,50px)',
          }}
        >
          <div
            style={{
              width: '200px',
              height: '200px',
              background: 'linear-gradient(90deg, #CC151E 0%, #8A325D 100%)',
              WebkitMask: 'url(/images/TringboxWhite.svg) no-repeat center',
              mask: 'url(/images/TringboxWhite.svg) no-repeat center',
              WebkitMaskSize: 'contain',
              maskSize: 'contain',
            }}
          />
        </div>

        <img className="col-10" src="/images/splash.gif" />
        <span
          style={{
            background: 'linear-gradient(90deg, #CC151E 0%, #8A325D 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            display: 'inline-block',
            fontSize: 'clamp(0px,7vw,30px)',
          }}
        >
          Celebrate in Style
        </span>
      </div>
    </div>
  );
}

export default App;
